import { render, staticRenderFns } from "./InfoNull.vue?vue&type=template&id=5010978a&scoped=true&"
import script from "./InfoNull.vue?vue&type=script&lang=js&"
export * from "./InfoNull.vue?vue&type=script&lang=js&"
import style0 from "./InfoNull.vue?vue&type=style&index=0&id=5010978a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010978a",
  null
  
)

export default component.exports